<template>
    <footer class="page-footer">{{$t("footer.icp1")}}   <span class="icp-num">{{$t("footer.icp2")}}</span></footer>
    <!-- <span class="foot-company">福建泉州迈达兴鞋业有限公司</span> -->
</template>

<script>
export default {
  name: 'pageLayoutFooter',
  data () {
    return {

    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {

    }
  }
}
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .page-footer{
   bottom 0;width: 100%;height: 70px;text-align center;font-size 14px;line-height 70px;color rgba(255,255,255,.65);background-color:#005bac;
    .icp-num{
      padding-left:.2rem;margin-left:.2rem;rela()
      &::after{content:'';abso();left:0;top:0;width:1px;height:100%;background:rgba(255,255,255,.5)}
    }
  }
      @media screen and (max-width: 768px){
        .foot-company{display:block}
        .icp-num{display:block;}
        .icp-num::after{display:none}
          .page-footer{
          font-size:.24rem;line-height: .4rem;    padding: .15rem 0;
              height: auto;}
      }
</style>
